"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpProductTile = void 0;
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const Helper_1 = require("../Helper");
const ClassesTags_1 = require("../ClassesTags");
const FilesTags_1 = require("../FilesTags");
const FavoriteController_1 = require("../../appProfiMall/controllers/FavoriteController");
const CartController_1 = require("../../appProfiMall/controllers/CartController");
class CmpProductTile extends tmpls_1.CmpProductTileBase {
    constructor() {
        super();
    }
    fill(product) {
        const ctrl = this.ctrls;
        ctrl.aName.text = product.name;
        ctrl.aName.el.setAttribute('href', "/product/" + product.id);
        ctrl.aImg.el.setAttribute('href', "/product/" + product.id);
        ctrl.lPrice.text = Helper_1.Helper.toPriceString(product.price);
        ctrl.lPriceOld.hide();
        [ctrl.statusOk, ctrl.statusNone, ctrl.statusDelivery].forEach(s => s.hide());
        if (product.remainder <= 0) {
            ctrl.statusNone.show();
            ctrl.btnAddToCart.disable();
        }
        else
            ctrl.statusOk.show();
        //TODO временное(удалить потом) 
        ctrl.lRemainderCount.text = product.remainder + "";
        if (product.rate < 0)
            ctrl.blockRate.hide();
        else
            ctrl.lRate.text = product.rate + "";
        //TODO сравнение
        ctrl.btnCompare.hide();
        ctrl.btnAddToCart.onclick = () => __awaiter(this, void 0, void 0, function* () {
            App_1.App.Inst.getInst(CartController_1.CartController).addProduct(product.id, 1, product.weightKg);
            //TODO Вообще нужно придумать другой способ обратной связи
            ctrl.btnAddToCart.text = "Добавлено";
            yield Helper_1.Helper.awaitTime(1000);
            ctrl.btnAddToCart.text = "В корзину";
        });
        const favoriteCtrl = App_1.App.Inst.getInst(FavoriteController_1.FavoriteController);
        let isFavorite = favoriteCtrl.isFavorite(product.id);
        this._setFavorite(isFavorite);
        ctrl.btnFavorite.onclick = (e) => {
            gs.events.stop(e);
            if (isFavorite)
                favoriteCtrl.removeFavorite(product.id);
            else
                favoriteCtrl.addFavorite(product.id);
            isFavorite = !isFavorite;
            this._setFavorite(isFavorite);
        };
        //TODO бонусы
        ctrl.blockBonus.hide();
        const mainFoto = product.fotos.find(f => f.tag == FilesTags_1.FilesTags.ImgMain);
        if (mainFoto) {
            ctrl.img1.src =
                ctrl.img2.src = "/fs/products/pv256/" + mainFoto.id;
        }
    }
    _setFavorite(value) {
        const btn = this.ctrls.btnFavorite;
        if (value)
            btn.addClass(ClassesTags_1.ClassesTags.Active);
        else
            btn.removeClass(ClassesTags_1.ClassesTags.Active);
    }
}
exports.CmpProductTile = CmpProductTile;
//# sourceMappingURL=CmpProductTile.js.map